import OrgAdminPage from "pages/org-performance/OrgAdminPage";
import OrgPayments from "pages/org-performance/PaymentsTab/PaymentsTab";

export default function Financials() {
  return (
    <OrgAdminPage>
      {(organization) => <OrgPayments organization={organization} />}
    </OrgAdminPage>
  );
}
